/**
 * The Measure tool's shortcut, keyed by `KeyboardEvent.code` like the brush and
 * selection-mode keys, so the binding survives a non-US layout.
 */
export const MEASURE_HOTKEY_CODE = 'KeyM';

/** Single-letter label for tooltips. */
export const MEASURE_HOTKEY_LABEL = MEASURE_HOTKEY_CODE.replace(/^Key/, '');
